import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    Paper,
    InputAdornment,
    IconButton,
    Divider,
    Stack,
} from "@mui/material";
import {
    MailOutline as MailIcon,
    LockOutlined as LockIcon,
    Visibility,
    VisibilityOff,
    VpnKeyOutlined as KeyIcon,
    ArrowBack,
} from "@mui/icons-material";

import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";

import { Turnstile } from "@marsidev/react-turnstile";
import { apiUrl } from "../../comp/ApiUrl";

class Conta extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            captchaToken: '',
            showPassword: false,
        };
    }

    // Alternar visibilidade da senha
    handleTogglePassword = () => {
        this.setState((prevState) => ({
            showPassword: !prevState.showPassword,
        }));
    };

    // Handler para inputs genéricos
    handleChange = (e) => {
        const { id, value } = e.target;
        this.setState({ [id]: value });
    };

    // Login via Email/Senha
    handleSubmit = (e) => {
        e.preventDefault();
        const { email, password } = this.state;
        console.log("Login com Email:", { email, password });
        // Lógica de submissão aqui
    };

    // Sucesso no Google Login

    handleGoogleSuccess = (credentialResponse) => {
        const toastId = toast.loading("Autenticando...");
        const storeSlug = window.location.pathname.split("/").pop();

        fetch(`/api/oauth/google/store/${storeSlug}`, {
            credentials: "include", // Garante a recepção do Set-Cookie
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                credential: credentialResponse.credential,
            }),
        })
            .then((res) => {
                if (res.ok) {
                    toast.update(toastId, {
                        render: "Sucesso! Redirecionando...",
                        type: "success",
                        isLoading: false,
                        autoClose: 2000,
                    });

                    // Aguarda a gravação física do cookie pelo navegador antes de mudar de página
                    setTimeout(() => {
                        window.location.href = `https://${storeSlug}.fazpedido.app`;
                    }, 300);
                } else {
                    toast.update(toastId, {
                        render: "Falha na autenticação.",
                        type: "error",
                        isLoading: false,
                        autoClose: 3000,
                    });
                }
            })
            .catch(() => {
                toast.update(toastId, {
                    render: "Erro de conexão.",
                    type: "error",
                    isLoading: false,
                    autoClose: 3000,
                });
            });
    };

    render() {
        const { email, password, showPassword } = this.state;

        return (
            <Box sx={{
                p: 4,
                borderRadius: 4,
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}>




                <Box sx={{ textAlign: "center", mb: 2 }}>
                    <Typography variant="h5" component="h1" fontWeight="bold">
                        Entrar na sua conta
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Digite suas credenciais para acessar
                    </Typography>
                </Box>

                {/* Google Login Container */}
                <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                    <GoogleOAuthProvider clientId="992901332964-450q4r6gduuii5fo9be5ec8hnbk0rk56.apps.googleusercontent.com">
                        <GoogleLogin
                            onSuccess={this.handleGoogleSuccess}
                            onError={() => console.log("Login Falhou")}
                            useOneTap
                            theme="filled_blue"
                            width="100%"
                        />
                    </GoogleOAuthProvider>
                </Box>

                <Divider sx={{ my: 1 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ px: 1 }}>
                        OU CONTINUE COM EMAIL
                    </Typography>
                </Divider>

                <form onSubmit={this.handleSubmit}>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            id="email"
                            label="Email"
                            variant="outlined"
                            type="email"
                            required
                            value={email}
                            onChange={this.handleChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <MailIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <TextField
                            fullWidth
                            id="password"
                            label="Senha"
                            variant="outlined"
                            type={showPassword ? "text" : "password"}
                            required
                            value={password}
                            onChange={this.handleChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={this.handleTogglePassword} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Box sx={{ textAlign: "right" }}>
                            <Button
                                size="small"
                                component={Link}
                                to="/forgot-password"
                                startIcon={<KeyIcon sx={{ width: 14 }} />}
                                sx={{ textTransform: "none" }}
                            >
                                Esqueceu a senha?
                            </Button>
                        </Box>


                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Turnstile

                                siteKey="0x4AAAAAADD5XelpNdivqvNc"
                                onSuccess={(token) => {

                                    this.setState({ captchaToken: token });
                                }}
                            />
                        </div>



                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={this.state.captchaToken === ''}
                            size="large"
                            sx={{
                                borderRadius: 3,
                                py: 1.5,
                                fontWeight: "bold",
                                textTransform: "none",
                                boxShadow: "0 4px 14px 0 rgba(0,118,255,0.39)",
                            }}
                            onClick={() => {
                                var { email, password, captchaToken } = this.state;
                                fetch(`/api/oauth/login/store/${window.location.pathname.split("/").pop()}`, {
                                    credentials: "include",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({
                                        email,
                                        password,
                                        captchaToken
                                    }),
                                })
                                    .then((res) => {

                                        if (res.status === 200) {
                                            window.location.href = `https://${window.location.pathname.split("/").pop()}.fazpedido.app`;
                                        }

                                        if (res.status === 401) {
                                            toast.error("Captcha Invalido")
                                        }

                                        if (res.status === 403) {
                                            toast.warn("Você excedeu o limite de tentativas de login")

                                        }


                                        if (res.status === 404) {
                                            toast.error("Usuário ou senha incorretos")
                                        }

                                    })
                            }}
                        >
                            Entrar
                        </Button>
                    </Stack>
                </form>

                <Box sx={{ mt: 2, textAlign: "center" }}>
                    <Typography variant="body2" color="text.secondary">
                        Não tem uma conta?{" "}
                        <Button
                            component={Link}
                            to="register"
                            sx={{ textTransform: "none", fontWeight: "bold", p: 0, minWidth: "auto", ml: 0.5 }}
                        >
                            Criar conta
                        </Button>
                    </Typography>
                </Box>




            </Box>
        );
    }
}

export default Conta;